//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getStyle } from '@/utils/style'
import ComponentWrapper from '@/components/Editor/ComponentWrapper'
import { changeStyleWithScale } from '@/utils/translate'

export default {
    components: { ComponentWrapper },
    data() {
        return {
            canvasStyleData: { // 页面全局数据
                width: 1200,
                height: 740,
                scale: 100,
            },
            componentData: [], // 画布组件数据
            loading: false
        }
    },
    created() {
        var token = this.$route.query.A
        var id = this.$route.query.I
        if(token) {
            this.$store.commit('SET_STATUS', token)
            this.$store.commit('setEditMode', 'preview')
            this.getComponentData(id)
        } else {
            this.$message({
                message: '没有预览权限',
                type: 'error',
                duration: 3 * 1000
            })
        }
        // this.componentData = JSON.parse(JSON.parse(localStorage.getItem('canvasData')))
        // this.canvasStyleData = JSON.parse(localStorage.getItem('canvasStyle'))
    },
    methods: {
        changeStyleWithScale,
        getStyle,
        getComponentData(id) {
            this.loading = true
            this.request({
                url: '/web/preview/' + id,
                method: 'get',
            }).then(response => {
                let result = response.result
                this.componentData = JSON.parse(result.substring(1, result.length - 1))
                this.loading = false
            }).catch(error => {
                this.loading = false
                this.$message({
                    message: error.errmsg == undefined ? '页面解析异常' : error.errmsg,
                    type: 'error',
                    duration: 3 * 1000
                })
            })
            // console.log(peview);
        }
        
    }
    
}
